(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('ProviderSegmentDeleteController',ProviderSegmentDeleteController);

    ProviderSegmentDeleteController.$inject = ['$uibModalInstance', 'entity', 'ProviderSegment'];

    function ProviderSegmentDeleteController($uibModalInstance, entity, ProviderSegment) {
        var vm = this;

        vm.providerSegment = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ProviderSegment.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
